import { apiClient } from '../../axios';
import {
  GetAgreementDetailParams,
  GetAgreementDetailResponse,
  GetAgreementResponse,
  PostAgreementParams,
} from './types';

export const getAgreementApi = () => apiClient.get<GetAgreementResponse>('/v1/agreement');
export const postAgreementApi = (params: PostAgreementParams) =>
  apiClient.post<GetAgreementResponse>('/v1/agreement', params);
export const getAgreementDetailsApi = (params: GetAgreementDetailParams) =>
  apiClient.get<GetAgreementDetailResponse>('/v1/agreement/details', { params });
